import styled from 'styled-components'

const MEMBERS_PURPLE = '#200769'
const MEMBERS_ACCENT = '#5F2EC7'
const MEMBERS_LIGHT = '#e8e4f3'

export const MembersPageWrapper = styled.main`
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 16px 48px;
  font-family: Outfit, sans-serif;

  .dark-theme & {
    --members-bg: rgba(37, 38, 42, 0.6);
    --members-card: rgba(45, 46, 51, 0.95);
    --members-border: rgba(255, 255, 255, 0.08);
  }

  @media (min-width: 768px) {
    padding: 32px 24px 64px;
  }
`

export const StatsStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
`

export const StatCard = styled.div`
  flex: 1 1 180px;
  min-width: 140px;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border-radius: 14px;
  border: 1px solid rgba(32, 7, 105, 0.06);
  box-shadow: 0 4px 20px rgba(32, 7, 105, 0.06);

  .dark-theme & {
    background: rgba(45, 46, 51, 0.9);
    border-color: rgba(255, 255, 255, 0.06);
  }
`

export const StatLabel = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5c5c7a;
  margin-bottom: 4px;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.6);
  }
`

export const StatValue = styled.span`
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1a0a4e;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.95);
  }
`

export const ProgressSection = styled.div`
  margin-bottom: 24px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  border: 1px solid rgba(32, 7, 105, 0.08);
  box-shadow: 0 4px 24px rgba(32, 7, 105, 0.06);

  .dark-theme & {
    background: rgba(45, 46, 51, 0.9);
    border-color: rgba(255, 255, 255, 0.06);
  }
`

export const ProgressLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #1a0a4e;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.9);
  }
`

export const ProgressTrack = styled.div`
  height: 10px;
  background: ${MEMBERS_LIGHT};
  border-radius: 10px;
  overflow: hidden;

  .dark-theme & {
    background: rgba(255, 255, 255, 0.1);
  }
`

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, ${MEMBERS_ACCENT} 0%, ${MEMBERS_PURPLE} 100%);
  border-radius: 10px;
  transition: width 0.4s ease;
`

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  border-radius: 14px;
  border: 1px solid rgba(32, 7, 105, 0.08);

  .dark-theme & {
    background: rgba(45, 46, 51, 0.9);
    border-color: rgba(255, 255, 255, 0.06);
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const SearchInput = styled.input`
  flex: 1 1 240px;
  min-width: 200px;
  padding: 10px 16px;
  font-size: 14px;
  font-family: Outfit, sans-serif;
  color: #1a0a4e;
  background: #fff;
  border: 1px solid rgba(32, 7, 105, 0.12);
  border-radius: 10px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  &::placeholder {
    color: #9a9ab0;
  }

  &:focus {
    border-color: ${MEMBERS_ACCENT};
    box-shadow: 0 0 0 3px rgba(95, 46, 199, 0.15);
  }

  .dark-theme & {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.12);
    color: rgba(255, 255, 255, 0.95);

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }

    &:focus {
      border-color: ${MEMBERS_ACCENT};
    }
  }
`

export const ToolbarActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
`

export const ActionBtn = styled.button`
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  font-family: Outfit, sans-serif;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.15s;
  white-space: nowrap;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.92;
    transform: translateY(-1px);
  }

  &.primary {
    background: linear-gradient(135deg, ${MEMBERS_ACCENT} 0%, ${MEMBERS_PURPLE} 100%);
    color: white;
  }

  &.secondary {
    background: rgba(32, 7, 105, 0.08);
    color: #1a0a4e;

    .dark-theme & {
      background: rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.9);
    }
  }
`

export const TableCard = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  border: 1px solid rgba(32, 7, 105, 0.08);
  box-shadow: 0 4px 24px rgba(32, 7, 105, 0.06);
  overflow: hidden;

  .dark-theme & {
    background: rgba(45, 46, 51, 0.9);
    border-color: rgba(255, 255, 255, 0.06);
  }
`

export const TableWrapper = styled.div`
  overflow-x: auto;
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`

export const TableHead = styled.thead`
  background: rgba(32, 7, 105, 0.04);

  .dark-theme & {
    background: rgba(255, 255, 255, 0.04);
  }
`

export const TableHeadCell = styled.th`
  padding: 14px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #5c5c7a;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.7);
  }

  &:first-child {
    padding-left: 20px;
    width: 44px;
  }

  &:last-child {
    padding-right: 20px;
    width: 56px;
  }
`

export const TableRow = styled.tr`
  transition: background 0.15s;

  &:hover {
    background: rgba(32, 7, 105, 0.03);

    .dark-theme & {
      background: rgba(255, 255, 255, 0.04);
    }
  }
`

export const TableCell = styled.td`
  padding: 14px 16px;
  color: #1a0a4e;
  vertical-align: middle;
  border-top: 1px solid rgba(32, 7, 105, 0.06);

  .dark-theme & {
    color: rgba(255, 255, 255, 0.9);
    border-color: rgba(255, 255, 255, 0.06);
  }

  &:first-child {
    padding-left: 20px;
  }

  &:last-child {
    padding-right: 20px;
  }
`

export const MemberName = styled.span`
  font-weight: 600;
  color: #1a0a4e;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.95);
  }
`

export const MemberEmail = styled.span`
  color: #5c5c7a;
  font-size: 13px;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.65);
  }
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;

  &.active {
    background: rgba(34, 197, 94, 0.14);
    color: #16a34a;
  }

  &.revoked,
  &.expire {
    background: rgba(239, 68, 68, 0.14);
    color: #dc2626;
  }

  &.renew {
    background: rgba(249, 115, 22, 0.14);
    color: #ea580c;
  }

  &.pending {
    background: rgba(59, 130, 246, 0.14);
    color: #2563eb;
  }

  .dark-theme &.active {
    background: rgba(34, 197, 94, 0.2);
    color: #4ade80;
  }

  .dark-theme &.revoked,
  .dark-theme &.expire {
    background: rgba(239, 68, 68, 0.2);
    color: #f87171;
  }
`

export const PaginationBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  border-top: 1px solid rgba(32, 7, 105, 0.06);

  .dark-theme & {
    border-color: rgba(255, 255, 255, 0.06);
  }
`

export const PaginationInfo = styled.div`
  font-size: 13px;
  color: #5c5c7a;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.6);
  }
`

export const PageSizeSelect = styled.select`
  padding: 8px 12px;
  font-size: 13px;
  font-family: Outfit, sans-serif;
  color: #1a0a4e;
  background: #fff;
  border: 1px solid rgba(32, 7, 105, 0.12);
  border-radius: 8px;
  outline: none;
  cursor: pointer;

  .dark-theme & {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.9);
    border-color: rgba(255, 255, 255, 0.12);
  }
`

export const EmptyState = styled.div`
  padding: 64px 24px;
  text-align: center;
`

export const EmptyStateTitle = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: #1a0a4e;
  margin: 0 0 8px 0;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.95);
  }
`

export const EmptyStateText = styled.p`
  font-size: 14px;
  color: #5c5c7a;
  margin: 0;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.6);
  }
`
